import Vue from 'vue';
import { Workbox } from 'workbox-window';

export default class PWAUtils {
  private static workBox: Workbox;

  constructor(hasServiceWorker: boolean) {
    if (!this.isSupported) {
      return;
    }
    if (hasServiceWorker) {
      // Single instance of workBox
      if (!PWAUtils.workBox) {
        const showUpdateNotification = () => {
          Vue.$dialog.notify(Vue.$t('core.app.notification.newVersion.title'), Vue.$t('core.app.notification.newVersion.message'))
            .then(() => {
              this.doUpdate();
            });
        };

        PWAUtils.workBox = new Workbox(`${process.env!.BASE_URL}service-worker.js`);
        PWAUtils.workBox.addEventListener('waiting', (event) => {
          this.pwaValues.hasUpdate = true;
          showUpdateNotification();
          if (event.sw) {
            event.sw.addEventListener('statechange', (e: Event) => {
              if (event.sw?.state === 'activated') {
                this.pwaValues.hasUpdate = false;
              }
            });
          }
        });
        PWAUtils.workBox.register();
      }
    }
    const handleNetworkChange = (event: Event) => {
      this.pwaValues.isOnline = navigator.onLine;
    };
    window.addEventListener('online', handleNetworkChange);
    window.addEventListener('offline', handleNetworkChange);
  }

  private pwaValues = Vue.observable({
    isOnline: navigator.onLine,
    hasUpdate: false,
  });

  get isSupported() {
    return 'serviceWorker' in navigator;
  }

  get hasUpdate() {
    return this.pwaValues.hasUpdate;
  }

  get isOnline() {
    return this.pwaValues.isOnline;
  }

  doUpdate() {
    // Set up a listener that will reload the page as soon as the previously waiting
    // service worker has taken control.
    PWAUtils.workBox.addEventListener('controlling', (event: any) => {
      window.location.reload();
    });

    // Send a message telling the service worker to skip waiting.
    // This will trigger the 'controlling' event handler above.
    PWAUtils.workBox.messageSW({ type: 'SKIP_WAITING' });
  }

  clearCache() {
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => {
        caches.delete(cacheName);
      });
    });
  }

  showNotification(title: string, body: string) {
    if (!this.isSupported) {
      Vue.$log.warning(`Unable to show notification "${body}", this browser does not support Service-Workers`);
    } else {
      const notificationOptions: NotificationOptions = {
        body,
        badge: '/img/icons/android-chrome-96x96.png',
        icon: '/img/icons/android-chrome-192x192.png',
      };
        // returns a Promise, the active SW registration
      navigator.serviceWorker.ready
        .then((swreg) => {
          if (Notification.permission === 'granted') {
            swreg.showNotification(title, notificationOptions);
          } else {
            Notification.requestPermission((permission) => {
              if (permission === 'granted') {
                swreg.showNotification(title, notificationOptions);
              }
            });
          }
        });
    }
  }
}
